import React, { Component } from 'react';
import Config from '../../config';
import axios from 'axios';
import { CircularProgress } from '@mui/material';

interface LabelRedirectProps {
    type: string;
}

interface LabelRedirectState {
    loaded: boolean;
    url: string | null;
    redirect: string | null;
}

class LabelRedirect extends Component<LabelRedirectProps, LabelRedirectState> {
    state: LabelRedirectState = {loaded: false, url: null, redirect: null};
    getRequestUrl = (props: LabelRedirectProps) => {
        var type = props.type.toLowerCase();
        var url = Config.api + '/api/v1/';
        if(type === 'picklist'){
            url += 'orders/picklist'
        }
        else if(type === 'gs1label'){
            url += 'shipments/shippinglabel'
        }
        else if(type === 'packingslip'){
            url += 'shipments/packingslip'
        }
        url += window.location.search;
        return url;
    }
    async loadUrl(props: LabelRedirectProps){
        var requestUrl = this.getRequestUrl(props);
        if(requestUrl !== this.state.url){
            this.setState({loaded: false, url: requestUrl, redirect: null});
        }else{
            return;
        }
        var link = (await axios.get(requestUrl)).data.Body;
        this.setState({loaded: true, redirect: link});
        window.location.href = link;
    }
    async componentDidUpdate(){
        await this.loadUrl(this.props);
    }
    async componentDidMount(){
        await this.loadUrl(this.props);
    }
    render(){
        return <div style={{display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center'}}>
            <CircularProgress size={80}/>
        </div>;
    }
}

export default LabelRedirect;
